import Vue from 'vue'
import Vuex from 'vuex'
import qa from './content/qa.js'
import general from './content/general.js'
import image from './content/image.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    qa,
    general,
    userQuiz: null,
    userScore: 0,
    totalScore: 0,
    countStep: 0,
    routeName: '',
    image
  },
  getters: {
    fetchScore (state) { return state.userScore },
    fetchTotal (state) { return state.totalScore },
    fetchStep (state) { return state.countStep },
    contentGeneral (state) { return state.general.general },
    checkIfQuestions (state) { return state.userQuiz }
  },
  mutations: {
    MUTATE_GET (state, payload) {
      state.countStep = 0
      state.totalScore = 0
      state.userScore = 0
      state.userQuiz = state.qa
    },
    MUTATE_SCORE (state, payload) {
      const getScore = state.userScore
      state.userScore = getScore + payload.score
    },
    MUTATE_TOTAL (state, payload) {
      const getScore = state.totalScore
      state.totalScore = getScore + 2
    },
    MUTATE_STEP (state, payload) {
      const getScore = state.countStep
      state.countStep = getScore + 1
    }
  },
  actions: {
    GET_QUESTIONS ({ commit }, payload) {
      commit({ type: 'MUTATE_GET' })
    },
    UPDATE_SCORE ({ commit }, payload) {
      commit({
        type: 'MUTATE_SCORE',
        score: payload.score
      })
    },
    UPDATE_TOTAL ({ commit }, payload) {
      commit({
        type: 'MUTATE_TOTAL',
        total: payload.total
      })
    },
    UPDATE_STEP ({ commit }, payload) {
      commit({
        type: 'MUTATE_STEP',
        step: payload.step
      })
    }
  }
})
